import { h } from 'preact'
import {
  colors,
  supportColors,
  administrationDisclaimer,
} from '../../constants'

const Support = ({ support, margin, administration, small }) => (
  <div style={{ marginTop: '15px', display: 'inline-block' }}>
    <div
      style={{
        fontSize: small ? '16px' : '22px',
        height: small ? 40 : 50,
        fontWeight: 600,
        lineHeight: '20px',
        display: 'inline-block',
        color: '#fff',
        padding: small ? '12px 15px 5px 15px' : '17px 20px 10px 20px',
        marginBottom: 10,
        marginRight: margin ? 50 : 0,
        backgroundColor: administration
          ? colors.darkGrey
          : supportColors[support] || supportColors.nehlasuje,
      }}
      data-tip={administration ? administrationDisclaimer : ''}
      data-class={'gt930 tooltip'}
    >
      {administration ? 'člen vlády' : support}
    </div>
  </div>
)
export default Support



// WEBPACK FOOTER //
// ./components/PoliticianDetail/Support.js